export const environment = {
  BASE_URL: 'https://<myfirebaseproject>.firebaseapp.com',
  production: true,
  firebase: {
    apiKey: "AIzaSyChC0x63GBnBjfMDSgRCeThHIDNpE8bkLM",
    authDomain: "hiring-uat-d0d0a.firebaseapp.com",
    databaseURL: "https://hiring-uat-d0d0a.firebaseio.com",
    projectId: "hiring-uat-d0d0a",
    storageBucket: "hiring-uat-d0d0a.appspot.com",
    messagingSenderId: "700264188304",
    appId: "1:700264188304:web:ba04a8653cb89e2c93cb15",
    measurementId: "G-V8NP13SZXK"
  }
};
